import { SVGProps } from 'react';

const AudioWaveform = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2 13a2 2 0 0 0 2-2V7a2 2 0 1 1 4 0v13a2 2 0 0 0 4 0V4a2 2 0 1 1 4 0v13a2 2 0 0 0 4 0v-4a2 2 0 0 1 2-2"
    />
  </svg>
);
export default AudioWaveform;
